import styled from 'styled-components';

export const Hero = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 320px;
`;
